import defaultSettings from '../settings.json';
import { createStore } from 'redux';
const initialState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {}
  },
  BizStatus: {},
  BizType: {},
  Actions: {},
  PurchaseType: {},
  DefectType: [],
  WarehouseType: {},
  InboundType: {},
  OutboundType: {},
  StockFlowType: {},
  TaskType: {},
  CommonStatus: {},
  CommonStatusMap: {},
  operRules: []
};
function rootReducer(state = initialState, action) {
  switch (action.type) {
    case 'update-settings':
      {
        const {
          settings
        } = action.payload;
        return {
          ...state,
          settings
        };
      }
    case 'update-userInfo':
      {
        const {
          userInfo = initialState.userInfo,
          userLoading
        } = action.payload;
        return {
          ...state,
          userLoading,
          userInfo
        };
      }
    case 'update-oper-rules':
      {
        const {
          operRules = initialState.operRules
        } = action.payload;
        return {
          ...state,
          operRules
        };
      }
    case 'update-biz-enum':
      {
        const {
          BizStatus = initialState.BizStatus,
          BizType = initialState.BizType,
          Actions = initialState.Actions,
          PurchaseType = initialState.PurchaseType,
          WarehouseType = initialState.WarehouseType,
          InboundType = initialState.InboundType,
          OutboundType = initialState.OutboundType,
          StockFlowType = initialState.StockFlowType,
          TaskType = initialState.TaskType,
          CommonStatus = initialState.CommonStatus
        } = action.payload;
        return {
          ...state,
          BizStatus,
          BizType,
          Actions,
          PurchaseType,
          WarehouseType,
          InboundType,
          OutboundType,
          StockFlowType,
          TaskType,
          CommonStatus
        };
      }
    case 'update-common-status-map':
      {
        const {
          CommonStatusMap = initialState.CommonStatusMap
        } = action.payload;
        return {
          ...state,
          CommonStatusMap
        };
      }
    case 'update-defect-type':
      {
        const {
          DefectType = initialState.DefectType
        } = action.payload;
        return {
          ...state,
          DefectType
        };
      }
    default:
      return state;
  }
}
const storeInstance = createStore(rootReducer);
export default storeInstance;